import { createStore } from "redux";
import {contracts} from "../redux/reducers/contracts";

export default createStore(contracts);
